import { queryOptions } from "@tanstack/react-query";

import { fetchVoucherCartItems } from "./requests";

const VoucherCartItemsQueries = {
  cartItems: (voucherCartUuid: string) =>
    queryOptions({
      queryKey: ["voucherCart", voucherCartUuid, "voucherCartItems"],
      queryFn: () => fetchVoucherCartItems(voucherCartUuid),
    }),
};
export default VoucherCartItemsQueries;
